// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".d0b0a33f6fce8912371a473ac00eb19a7fce8ac5.chunk.bundle.js";
};